<div>
    <canvas #ntCnvs>
    </canvas>

    <!-- Container of coordinates on the top-right corner -->
    <div class="crd">{{coordinates}}</div>
</div>
